import React from 'react';
import DocumentosVersionadosPage from "../../components/documentos/DocumentosVersionadosPage";
import AdicionarContratoEnderecoFiscal from "./components/AdicionarContratoEnderecoFiscal";

function ContratoEnderecoFiscal() {
    return (
        <DocumentosVersionadosPage
            title="Contrato de Endereço Fiscal"
            subtitle="Histórico de versões do contrato do serviço de endereço fiscal."
            listEndpoint="listarContratosEnderecoFiscal"
            responseKey="contratosEnderecosFiscais"
            getId={(contrato) => contrato?.idContratoEnderecoFiscal}
            addLabel="Nova versão"
            emptyMessage="Nenhum contrato de endereço fiscal encontrado."
            renderAddDialog={({ open, onClose }) => (
                <AdicionarContratoEnderecoFiscal adicionarContrato={open} setAdicionarContrato={(value) => !value && onClose()} />
            )}
        />
    );
}

export default ContratoEnderecoFiscal;
